import React from "react";
import Contactus1 from "../components/Contactus/Contactus1";
import Contactus2 from "../components/Contactus/Contactus2";
import SEO from "../components/SEO";

const contactSchema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "Contact Transforma | Global Office Locations",
  "provider": {
    "@type": "Organization",
    "name": "Transforma Pvt Ltd",
    "url": "https://www.transforma.in/company/contactus",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+91-9445300978",
        "contactType": "corporate head office",
        "areaServed": "IN",
        "availableLanguage": ["en", "ta"]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-732-379-2885",
        "contactType": "US regional office",
        "areaServed": "US",
        "availableLanguage": "en"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+49-151-52534628",
        "contactType": "Europe regional office",
        "areaServed": "DE",
        "availableLanguage": ["en", "de"]
      }
    ]
  },
  "description": "Contact Transforma's offices around the world. Find physical addresses, telephone contacts, and maps for our corporate locations in Chennai (India), Edison (New Jersey, USA), and Mainz (Germany).",
  "keywords": "contact transforma, transforma office locations, digital publishing head office chennai, transforma edison nj usa, linus-it mainz germany, global publishing solutions address"
};

const Contactus = () => {
  return (
    <>
    <SEO
        title="Contact Us | Transforma Global Offices (India, USA, Germany)"
        description="Get in touch with Transforma. Explore our worldwide corporate office locations across Chennai India, Edison New Jersey USA, and Mainz Germany along with structural direct line phone numbers and map navigation support."
        keywords="contact transforma, transforma office address, chennai koyambedu corporate office, transforma edison nj, linus-it mainz germany, tech publishing contact numbers, global backend support desk, customer support"
        canonical="https://www.transforma.in/company/contactus"
        schema={contactSchema}
      />
    <div className="w-full flex flex-col items-center ruler">
      <Contactus1 />
      <Contactus2 />
    </div>
    </>
  );
};

export default Contactus;
